import React from 'react'
import PropTypes from 'prop-types'
import { StyledModal } from './component.styles'
import AddStatement from './AddStatement'
import ModalHeader from 'components/ModalHeader'
import ModalIntro from 'components/ModalIntro'
import ModalFooter from 'components/ModalFooter'
import ModalOutro from 'components/ModalOutro'

const PurposeModal = ({
  currentStep,
  errors,
  flowLabel,
  goBack,
  handleCancel,
  handleCancelButtonClick,
  handleChange,
  handleClose,
  handleNextButtonClick,
  hasApiError,
  hideOutro,
  isSubmitting,
  modals,
  purposeIsCompleted,
  touched,
  values,
}) => {
  const currentModal = modals?.[currentStep] || {}
  const { cancelLabel, helpCopy, nextLabel } = currentModal
  const shouldSave = currentStep === 1

  return (
    !!modals && (
      <StyledModal
        dataTestId="step-modal-modal"
        isModalOpen={true}
        modalClose={() => handleClose}
      >
        <ModalHeader
          flowLabel={flowLabel}
          handleCancel={handleCancel}
          handleClose={handleClose}
          handleGoBack={goBack}
          showBackButton={currentStep !== 0 && !purposeIsCompleted}
        />
        {currentStep === 0 && <ModalIntro modalData={modals[0]} />}
        {currentStep === 1 && (
          <AddStatement
            errors={errors}
            handleChange={handleChange}
            modalData={modals[1]}
            touched={touched}
            values={values}
          />
        )}
        {currentStep === 2 && !hideOutro && (
          <ModalOutro buttonOnClick={handleClose} modalData={modals[2]} />
        )}
        {currentStep !== 2 && (
          <ModalFooter
            cancelButtonText={cancelLabel}
            handleCancelButtonClick={() =>
              handleCancelButtonClick(shouldSave, false)
            }
            handleNextButtonClick={() =>
              handleNextButtonClick(shouldSave, true)
            }
            hasApiError={hasApiError}
            helpCopy={helpCopy}
            isSubmitting={isSubmitting}
            isValid={true}
            modalName="purpose"
            nextButtonText={nextLabel}
            showCancelButton={currentStep === 1 && !purposeIsCompleted}
          />
        )}
      </StyledModal>
    )
  )
}

PurposeModal.propTypes = {
  currentStep: PropTypes.number,
  errors: PropTypes.object,
  flowLabel: PropTypes.string,
  goBack: PropTypes.func,
  handleCancel: PropTypes.func,
  handleCancelButtonClick: PropTypes.func,
  handleChange: PropTypes.func,
  handleClose: PropTypes.func,
  handleNextButtonClick: PropTypes.func,
  hasApiError: PropTypes.bool,
  hideOutro: PropTypes.bool,
  isSubmitting: PropTypes.bool,
  isValid: PropTypes.bool,
  modals: PropTypes.array,
  purposeIsCompleted: PropTypes.bool,
  touched: PropTypes.object,
  values: PropTypes.object,
}

export default PurposeModal
